package de.oevbs.kunde.kundenportal2.model.services.deregistercar

import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class DeregisterCarClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Läd alle KFZ-Verträge des eingeloggten Users/Partners und gibt diese als [List<CarContract>] zurück.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun init(): ClientResponse<List<CarContract>> =
        get("/deregistercar/init")

    /**
     * Erzeugt einen Kontakt/Workitem im CRM, der dann von Service-Mitarbeitern bearbeitet wird, um ein Fahrzeug
     * ls verkauft/verschrottet oder abgemeldet zu melden.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun deregister(deregister: DeregisterCar): ClientResponse<Unit> =
        post("/deregistercar/deregister", deregister)
}